'use strict';

var _reactPercyTestFramework = require('@percy/react-percy-test-framework');

var _reactPercyTestFramework2 = _interopRequireDefault(_reactPercyTestFramework);

var _constants = require('./constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

global[_constants.GlobalVariables.rootSuite] = (0, _reactPercyTestFramework2.default)(global);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@percy/react-percy-webpack/lib/entry/framework.js
// module id = 474
// module chunks = 1